export default "__VITE_ASSET__5bf8ac52__"